import { FleetDocumentUpload } from "../documents/types";
import { FleetVehicle } from "../types";

/** Šifre stanja naloga — moraju odgovarati `VehicleServiceStatuses` na backendu. */
export enum VehicleServiceStatusEnum {
  RECEIVED = "received",
  IN_PROGRESS = "in_progress",
  DONE = "done",
  PICKED_UP = "picked_up",
}

export interface VehicleServiceStatus {
  id: string;
  name: string;
  color: string;
}

/** Šteta na nalogu — samo ono što treba za redak popisa. */
export interface VehicleServiceDamage {
  id: string;
  name: string;
  description: string | null;
  damageDate: Date | null;
  vehicleDamageStatusId: string | null;
  vehicleDamageStatusName: string | null;
  vehicleDamageStatusColor: string | null;
}

/**
 * Trošak nastao na nalogu. `invoiceIncomingItemId` je veza prema stavci ulaznog računa —
 * račun se ne veže na nalog izravno nego kroz trošak.
 */
export interface VehicleServiceExpense {
  id: string;
  name: string;
  expenseTypeId: string | null;
  expenseTypeName: string | null;
  expenseDate: Date | null;
  amount: number | null;
  invoiceIncomingItemId: string | null;
}

export interface FleetVehicleService {
  id: string;
  vehicleServiceStatus: VehicleServiceStatus | null;
  vehicle: FleetVehicle | null;
  contactId: string | null;
  contactName: string | null;
  name: string;
  description: string | null;
  receivedDate: Date | null;
  expectedDate: Date | null;
  completedDate: Date | null;
  /** Vozilo još nije preuzeto sa servisa. */
  isOpen: boolean;
  kmTraveled: number | null;
  created: Date | null;
  userCreatedName: string | null;
  damages: VehicleServiceDamage[];
  expenses: VehicleServiceExpense[];
  totalExpenses: number;
  documentUploads: FleetDocumentUpload[];
}

/** Redak popisa naloga; isti oblik kao detalj — popis prikazuje podskup polja. */
export type FleetVehicleServiceRow = FleetVehicleService;

export interface FleetVehicleServiceSearchFormValues {
  search: string | null;
  vehicleServiceStatusId: string | null;
  contactId: string | null;
  /** Kaskada vozila — model ovisi o marki, tip o modelu. */
  vehicleManufacturerId: string | null;
  vehicleModelId: string | null;
  vehicleTypeId: string | null;
  receivedDateFrom: Date | null;
  receivedDateTo: Date | null;
  /** Otvoreni (`true`), zatvoreni (`false`) ili svi (`null`). */
  isOpen: boolean | null;
  /** Popis vezan uz jedno vozilo (tab na kartici vozila). */
  vehicleId?: string | null;
}

/**
 * Unos naloga. Isti oblik koristi čarobnjak koji nalog otvara uz promjenu statusa vozila
 * i onaj koji ga uređuje s taba.
 */
export interface FleetVehicleServiceEditFormValues {
  id?: string | null;
  vehicleServiceStatusId: string;
  contactId: string | null;
  name: string | null;
  description: string | null;
  receivedDate: Date | null;
  expectedDate: Date | null;
  completedDate: Date | null;
  kmTraveled: number | null;
  /** Štete koje se nalogom rješavaju. */
  damageIds: string[];
  documentUploads: FleetDocumentUpload[];
}
